module.exports = __webpack_public_path__ + "img/task-10.6f3fc424.png";